import React, { useEffect } from 'react';
import SelectField from 'Shared/form/SelectField';
import { Col, Row } from 'react-bootstrap';
import PublisherTable from 'App/components/PublisherTable/PublisherTable';
import { useFormikContext } from 'formik';
import * as R from 'ramda';
import useFetchAssessmentPublisherList from './hooks/useFetchAssessmentPublisherList';

const AssessmentPublisherForm = () => {
    const { isSubmitting, values, setFieldValue, validateForm } = useFormikContext();
    const { rawList, therapyList, isLoading: isAssessmentsLoading } = useFetchAssessmentPublisherList();

    useEffect(() => {
        if (values.rawList !== rawList && rawList.length > 0) {
            setFieldValue('rawList', rawList, false);
        }
    }, [rawList, setFieldValue, values.rawList]);

    useEffect(() => {
        const therapy = values.selectedTherapy;

        if (therapy?.id) {
            setFieldValue(
                'availableRecords',
                values?.rawList?.filter((i) => i.groupId === therapy?.id)
            );
            setFieldValue('selectedRecords', []);
        } else {
            setFieldValue('availableRecords', []);
            setFieldValue('selectedRecords', []);
        }
    }, [setFieldValue, values?.rawList, values.selectedTherapy]);

    useEffect(() => {
        validateForm();
    }, [validateForm, values.selectedRecords]);

    const onActionClick = (item, moveTo) => {
        const { availableRecords, selectedRecords } = values;

        if (moveTo === 'selected') {
            setFieldValue(
                'availableRecords',
                availableRecords.filter((i) => i.id !== item.id)
            );
            setFieldValue('selectedRecords', [...selectedRecords, item]);
        } else {
            setFieldValue(
                'selectedRecords',
                selectedRecords.filter((i) => i.id !== item.id)
            );
            setFieldValue('availableRecords', [...availableRecords, item]);
        }
    };

    return (
        <>
            <Row>
                <Col md={6}>
                    <SelectField
                        options={therapyList}
                        isClearable
                        label="Select a therapeutic category"
                        fieldName="selectedTherapy"
                        getOptionValue={R.prop('id')}
                        getOptionLabel={R.prop('name')}
                        disabled={isSubmitting || isAssessmentsLoading}
                    />
                </Col>
            </Row>
            <PublisherTable
                tableName="Assessments"
                availableRecords={values.availableRecords}
                selectedRecords={values.selectedRecords}
                onActionClick={onActionClick}
                isLoading={isSubmitting || isAssessmentsLoading}
            />
        </>
    );
};

export default AssessmentPublisherForm;
